export class ReferenceFieldRowFormat {
  title: string;
  subtitle: string;
  additionalInformation: string;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/interfaces/reference-field-row-format.interface.ts